/**
 * Gets the color class for the score display based on the score value
 * Matches the color ranges used in ScoreDiagram
 *
 * @param score - The score value (0-100)
 * @returns Tailwind text color class
 */
export function getScoreColorClass(score: number): string {
  // Normalize score to 0-100 range
  const normalizedScore = Math.min(100, Math.max(0, score));

  if (normalizedScore < 20) {
    return 'text-error-700'; // Dark red (0-20)
  }

  if (normalizedScore < 40) {
    return 'text-error-500'; // Red (20-40)
  }

  if (normalizedScore < 60) {
    return 'text-warning-400'; // Amber/Yellow (40-60)
  }

  if (normalizedScore < 80) {
    return 'text-green-yellow-400'; // Light green (60-80)
  }

  return 'text-green-400'; // Green (80-100)
}
